import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { bucketApi, type UploadModelPhotoInput } from '~/supabase/bucket/api'

export const useUploadModelPhoto = () => {
  return useMutation({
    mutationKey: ['upload-model-photo'],
    mutationFn: (input: UploadModelPhotoInput) => bucketApi.uploadModelPhoto(input),
    onSuccess: () => {
      toast.success('Photo uploaded successfully')
    },
    onError: (error: Error) => {
      toast.error(error.message)
    },
  })
}
